import { h, Component } from "preact";
import toQuerystring from "to-querystring";

import UserWidget from "./UserWidget";
import MegaMenu from "./MegaMenu";

import addTalkus from "./talkus";
import getClient from "./platformshClient";

const ACCOUNT_MENU = [
  {
    label: "Account",
    value: "{accountUrl}/user"
  },
  {
    label: "Log Out",
    value: "{accountUrl}/user/logout"
  }
];

const linkFilter = (links, groupName) =>
  links
    .filter(l => l.group === groupName)
    .sort((l1, l2) => l1.weight - l2.weight);

class App extends Component {
  constructor(props) {
    super(props);

    this.state = { isLoading: true };
    this.toggleMegaMenu = this.toggleMegaMenu.bind(this);
    this.toggleProjectList = this.toggleProjectList.bind(this);
    this.getContext = this.getContext.bind(this);
    this.togglelinkList = this.togglelinkList.bind(this);
    this.accountMenu = [...props.customAccountMenuItems, ...ACCOUNT_MENU];

    if(props.includeSupport) {
      this.accountMenu.splice(this.accountMenu.length - 1, 0, {
        label: "Support",
        value: "{accountUrl}/support"
      });
    }
    if(props.includeBilling) {
      this.accountMenu.splice(this.accountMenu.length - 1, 0, {
        label: "Billing",
        value: "{accountUrl}/user/orders"
      },);
    }
    if(props.docsUrl && props.docsUrl !== "") {
      this.accountMenu.splice(this.accountMenu.length - 1, 0, {
        label: "Help",
        value: "{docsUrl}"
      },);
    }
  }

  updateContext(newProps) {
    this.getContext(newProps, this.state.isAdmin);
  }

  componentDidMount() {
    document.addEventListener("click", () => {
      this.setState({
        isMegaMenuOpen: false,
        isProjectListOpen: false,
        isLinkListOpen: false
      });
    });

    const activateTalkus = this.props.activateTalkus;

    fetch(`${this.props.accountUrl}/api/platform/self`, {
      credentials: "include"
    })
      .then(response => response.json())
      .then(data => {
        if (activateTalkus) {
          addTalkus(data);
        }
        if (data.mail) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({'email': data.mail});
        }
        const isAdmin = data.roles.indexOf("team member") !== -1;
        this.setState({
          isAdmin,
          client: this.props.betaToggle && getClient(this.props.accountUrl, this.props.api_url, this.props.clientId, this.props.access_token),
          displayName: data.label,
          currentUsername: data.username,
          avatarUrl: data.picture,
          projects: data.projects,
          isLoading: false,
          userId: data.uuid
        });
        localStorage.setItem('adminMode', 'disabled');

        this.getContext(this.props, isAdmin);

        window.onhashchange = () => {
          this.getContext(this.props, isAdmin);
        };
      })
      .catch(() => {
        if (activateTalkus) {
          addTalkus();
        }
        this.setState({ isLoading: false });
      });
  }

  getContext(props, isAdmin) {
    if (!isAdmin) {
      return false;
    }

    const { source, getQueryString } = props;
    const queryString = {
      context: {
        source,
        ...getQueryString(window.location.pathname)
      }
    };

    fetch(
      `${this.props.accountUrl}/api/platform/admin/context?${toQuerystring(
        queryString
      )}`,
      {
        credentials: "include"
      }
    )
      .then(response => response.json())
      .then(data => {
        this.setState({
          projectContext: {
            project: data._context.project,
            links: linkFilter(data.links, "Project")
          },
          userContext: {
            user: data._context.user,
            links: linkFilter(data.links, "User")
          },
          adminLinks: linkFilter(data.links, "Admin")
        });
      });
  }

  toggleMegaMenu(e) {
    e.stopPropagation();
    localStorage.setItem('adminMode', 'active');
    this.setState(state => ({
      client: getClient(this.props.accountUrl, this.props.api_url, this.props.clientId, this.props.access_token),
      isMegaMenuOpen: !state.isMegaMenuOpen,
      isProjectListOpen: false,
      isLinkListOpen: false
    }));
  }

  toggleProjectList() {
    this.setState(state => ({
      isProjectListOpen: !state.isProjectListOpen,
      isMegaMenuOpen: false,
      isLinkListOpen: false
    }));
  }

  togglelinkList() {
    this.setState(state => ({
      isLinkListOpen: !state.isLinkListOpen,
      isMegaMenuOpen: false,
      isProjectListOpen: false
    }));
  }

  goToProject({ uri }) {
    window.location = uri;
  }

  goToLink({ value }) {
    window.location = value;
  }

  render(
    {  accountUrl, showProjectsMenu, adminOnly, betaToggle},
    {
      avatarUrl,
      client = {},
      isMegaMenuOpen,
      isProjectListOpen,
      isLinkListOpen,
      displayName,
      projects = [],
      isAdmin,
      isLoading,
      currentUsername,
      userId,
      ...state = {}
    }
  ) {

    return (
      <div
        style={{ height: "100%" }}
        onClick={e => e.stopPropagation()}
        onKeyUp={e => e.keyCode === 13 && e.stopPropagation()}
        tabIndex="-1"
        role="document"
      >
        <UserWidget
          isLoading={isLoading}
          isAdmin={isAdmin}
          isMegaMenuOpen={isMegaMenuOpen}
          isLinkListOpen={isLinkListOpen}
          isProjectListOpen={isProjectListOpen}
          displayName={displayName}
          showProjectsMenu={showProjectsMenu}
          toggleProjectList={this.toggleProjectList}
          onClick={this.togglelinkList}
          onClickWheel={this.toggleMegaMenu}
          accountUrl={accountUrl}
          avatarUrl={avatarUrl}
          nameOrAvatar={this.props.nameOrAvatar}
          projects={projects}
          goToProject={this.goToProject}
          goToLink={this.goToLink}
          userId={userId}
          accountMenu={this.accountMenu}
          adminOnly={adminOnly}
          betaToggle={betaToggle}
          client={client}
        />
        {isAdmin && <MegaMenu open={isMegaMenuOpen} currentUsername={currentUsername} client={client} accountUrl={accountUrl} {...state} />}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js